'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react'

interface RuangDialogContextType {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
}

const RuangDialogContext = createContext<RuangDialogContextType | undefined>(undefined)

export const useRuangDialog = () => {
  const context = useContext(RuangDialogContext)
  if (!context) {
    throw new Error('useRuangDialog must be used within a RuangDialogProvider')
  }
  return context
}

export const RuangDialogProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)

  const openDialog = () => setOpen(true)
  const closeDialog = () => setOpen(false)

  return <RuangDialogContext.Provider value={{ open, openDialog, closeDialog }}>{children}</RuangDialogContext.Provider>
}
